import styled from 'styled-components';

export interface PaperInterface {
    asCard?: boolean;
    simple?:boolean;
    backgroundColor?: string;
    marginTop?: string;
    marginBottom?: string;
    marginLeft?: string;
    marginRight?: string;
    padding?: string;
    background?: string;
    border?: string;
}

export const PaperLayout = styled('div')<PaperInterface>`
    box-shadow: ${props=>(props.asCard?'0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)':'')};
    margin-bottom: ${props=>(props.marginBottom?props.marginBottom:'10px')};
    margin-top: ${props=>(props.marginTop?props.marginTop:'10px')};
    margin-left: ${props=>(props.marginLeft?props.marginLeft:'0px')};
    margin-right: ${props=>(props.marginRight?props.marginRight:'0px')};
    padding: ${props=>(props.padding?props.padding:'15px')};
    border-radius: 4px;
    background-color:${props=>(props.backgroundColor?props.backgroundColor:'white')};
    border: ${props=>(!props.asCard && !props.simple? props.border ?? '1px solid #e4e4e4e4':'')};
    width: 100%;
    background: ${props=>(props.background?`url(${props.background}) no-repeat`:'')};
    background-size: cover;
`;
